<template>
  <div class="display-container flex flex-col section_8">
    <div class="flex flex-row justify-between items-start">
      <div class="space-x-9">
        <div v-if="!data.titleHidden" class="font_4">{{ data.title }}</div>
        <div v-if="!data.subtitleHidden" class="font_7">
          {{ data.subtitle }}
        </div>
      </div>
      <div v-if="data.showMoreButton" class="more-wrap">
        <span class="font_5 text_14">更多</span>
        <img class="image_7" src="https://ysh-cdn.kaidicloud.com/test/home-page/2024/04/25/5b228aff321d47c18ec1ef371875389c.png" alt="" />
      </div>
    </div>

    <div class="content-wrapper">
      <img src="https://ysh-cdn.kaidicloud.com/test/2024/04/27/af6a04457b78484ba1e571e4dabcd30c.png" class="content-image" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {}
  },
  computed: {
    data() {
      return this.content[0]
    },
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.display-container {
  width: 686px;
  margin: 0 auto;
  background: url(https://ysh-cdn.kaidicloud.com/test/2024/04/27/4d0aec190c32426f92b45f8e5cf2705a.png);
  background-size: cover;
}

.more-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.content-wrapper {
  margin-top: 16px;
}
.content-image {
  width: 638px;
  height: 288px;
}

.section_8 {
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  .space-x-9 {
    & > *:not(:first-child) {
      margin-left: 18px;
    }
    .font_4 {
      font-size: 34px;
      line-height: 48px;
      font-weight: 500;
      color: #91540d;
    }
  }
  .font_5 {
    font-size: 24px;
    line-height: 34px;
    color: #999999;
  }
  .text_14 {
    font-size: 26px;
    line-height: 36px;
  }
  .image_7 {
    width: 8px;
    height: 14px;
    margin-left: 8px;
    flex-shrink: 0;
  }

  .font_7 {
    font-size: 24px;
    line-height: 34px;
    color: #bc986e;
    margin-left: 0 !important;
    margin-top: 4px;
  }
}

.font_5 {
  font-size: 24px;
  line-height: 34px;
  color: #999999;
}
</style>
